import React, { useState, useEffect  } from 'react';
import styles from './OtpRegisterModal.module.css';
import axios from "../../../../utils/api/axios";
import { DialogEnum, showDialog } from '../../../../utils/dialog/Dialog';
import { IAM_MFA_OTP, IAM_SERVER_MULTIFACTORPOLICY, IAM_SERVER_UNIFIEDPROFILE } from '../../../../utils/Config';
import { getCookie } from '../../../../utils/cookies/cookies';
import { InnocodeButton } from '@intsoft/innocode-core';

function OtpRegisterModal({ onClose, onSuccess }) {
  const [step, setStep] = useState("verify"); // 'verify', 'register-verify', 'existing-qrcode'
  const [currentPw, setCurrentPw] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [authCode, setAuthCode] = useState("");
  const [showSecretKey, setShowSecretKey] = useState(false);
  const [hasExistingPolicy, setHasExistingPolicy] = useState(false);
  const [otpPolicy, setOtpPolicy] = useState();

  
    // 비밀번호 표시 상태 추가
    const [showPassword, setShowPassword] = useState(false);

 // 초기 OTP 등록 상태를 확인합니다.
  useEffect(() => {
    const checkPolicy = async () => {
      const userId = getCookie("user_id");
      const conditions = [
            { field: "unifiedProfileId", operator: "EQUALS", value: userId },
          ];
      const params = {
          page: 0,
          size: 0,
          sortField: ["createdDate"],
          sortOrder: ["desc"],
          operator: "AND",
          conditions
      };
      try {
        const res = await axios.post(`${IAM_SERVER_MULTIFACTORPOLICY}/all`, params);

        const otpPolicy = res.data.data.data.find(p => p.factorType === 'TOTP');
        if (otpPolicy) {
          setOtpPolicy(otpPolicy);
          setHasExistingPolicy(true);
        }
      } catch (err) {
        console.error("정책 조회 실패", err);
      }
    };
    checkPolicy();
  }, []);

  // 비밀번호 검증
  const verifyPassword = async () => {
    const userId = getCookie("user_id");
    try {
      const res = await axios.post(`${IAM_SERVER_UNIFIEDPROFILE}/verify/password`, {
        password: currentPw,
        unifiedProfileId: userId
      });

      const data = res.data;
      if (data.code === 200 || data.success === true) {
        if (hasExistingPolicy) {
          setStep("existing-qrcode");
        } else {
          generateOtpQrCode(userId);
        }
      } else {
        showDialog(DialogEnum.DEFAULT, "실패", data.resultMessage || "현재 비밀번호가 일치하지 않습니다.");
      }
    } catch (err) {
      showDialog(DialogEnum.DEFAULT, "오류", "서버 오류가 발생했습니다.");
    }
  };

  // OTP QR 코드 생성 (최초 등록)
  const generateOtpQrCode = async (userId) => {
    try {
      const response = await axios.post(`${IAM_MFA_OTP}/register`, {
        unifiedProfileId: userId
      });
      const { secretKey, qrCodeUrl } = response.data.data;
      setSecretKey(secretKey);
      setQrCodeUrl(qrCodeUrl);
      setStep("register-verify");
    } catch (error) {
      showDialog(DialogEnum.DEFAULT, "오류", "OTP QR 코드 생성에 실패했습니다.");
    }
  };

  // 기존 SecretKey로 QR 코드만 가져오기 (재등록)
  const getExistingQrCode = async (userId) => {
    try {
      const response = await axios.get(`${IAM_MFA_OTP}/qrcode/${userId}`);
      const { qrCodeUrl } = response.data.data;
      setSecretKey("");
      setQrCodeUrl(qrCodeUrl);
      setStep("register-verify");
    } catch (error) {
      showDialog(DialogEnum.DEFAULT, "오류", "QR 코드 불러오기에 실패했습니다.");
    }
  };

  // 인증 코드 검증 및 시크릿 키 등록
  const verifyAndRegister = async () => {
    if (!authCode || authCode.length !== 6) {
      showDialog(DialogEnum.DEFAULT, "경고", "6자리 인증 코드를 입력해주세요.");
      return;
    }
    const userId = getCookie("user_id");
    try {
      const res = await axios.post(`${IAM_MFA_OTP}/register/verify`, {
        unifiedProfileId: userId,
        code: parseInt(authCode, 10),
        secretKey: secretKey
      });


      if (res.data.data.verified) {
        showDialog(DialogEnum.DEFAULT, "성공", "OTP가 성공적으로 등록되었습니다.");
        onSuccess();
        onClose();
      } else {
        showDialog(DialogEnum.DEFAULT, "실패", "인증 코드가 일치하지 않습니다.");
      }
    } catch (err) {
      showDialog(DialogEnum.DEFAULT, "오류", "인증 코드 검증에 실패했습니다.");
    }
  };

  // 기존 시크릿 키 삭제
  const handleDeletePolicy = async () => {
    const userId = getCookie("user_id");

    showDialog(DialogEnum.CONFIRM, "알림", "기존 OTP 설정을 삭제하시겠습니까?", async () => {
      try {
        await axios.post(`${IAM_SERVER_MULTIFACTORPOLICY}/delete/${otpPolicy.multiFactorPolicyId}`);
        showDialog(DialogEnum.DEFAULT, "알림", "OTP 설정이 삭제되었습니다. 페이지를 새로고침하면 다시 등록할 수 있습니다.");
        onClose();
      } catch (error) {
          showDialog(DialogEnum.DEFAULT, "오류", "OTP 설정 삭제 중 오류가 발생했습니다.");
      }
    });
  };

  return (
    <div className={styles.layer__popWrap}>
      <div className={`${styles.layer__popCont} ${styles.user}`}>
        <div className={`${styles.layer__popHeader} ${styles.detail}`}>                 {/* 모달 헤더 */} 
          <h1 className={`innocode-typography--headline-md innocode-typography--bold ${styles.contentAreaTitleText}`}>
             OTP 설정
          </h1>
          <InnocodeButton
              theme={"opacity"}
              designType='assistive'
              enablePadding={false}
              iconOnly={true}
              icon={<svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
              </svg>
              }
              onClick={onClose}
          />
        </div>
        <div className={styles.layer__popDetail}>   
          <>
            {/* 1단계: 현재 비밀번호 확인 */}
            {step === "verify" && (
              <div className={styles.verifyFormContainer}> {/* 구글 스타일 폼 컨테이너 */}
                <h3 className={styles.verifyTitle}>계속하려면 먼저 본인임을 인증하세요.</h3>
                <div className={styles.passwordInputGroup}>
                  <label htmlFor="current-password" className={styles.passwordLabel}>비밀번호 입력</label>
                  <input
                    id="current-password"
                    className={styles.passwordInputField}
                    type={showPassword ? "text" : "password"}
                    value={currentPw}
                    onChange={(e) => setCurrentPw(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        verifyPassword();
                      }
                    }}
                    aria-label="현재 비밀번호 입력"
                  />
                </div>
                <div className={styles.showPasswordContainer}>
                  <input
                    type="checkbox"
                    id="show-password"
                    className={styles.showPasswordCheckbox}
                    checked={showPassword}
                    onChange={() => setShowPassword(!showPassword)}
                  />
                  <label htmlFor="show-password" className={styles.showPasswordLabel}>비밀번호 표시</label>
                </div>
                <div className={styles.verifyButtonRow}>
                  <InnocodeButton
                    size="md"
                    designType="primary" 
                    fullWidth={true}
                    className={styles.nextButton}
                    onClick={verifyPassword}
                  >다음</InnocodeButton>
                  {/* <button className={styles.nextButton} onClick={verifyPassword}>다음</button> */}
                </div>
              </div>
            )}

            {/* 2단계: OTP 최초 등록 후 코드 검증 */}
            {step === "register-verify" && (
              <>
                <p>Authenticator 앱을 사용하여 QR 코드를 스캔하세요.</p>
                <p>
                    OTP 앱이 없으신가요?<br/>
                    <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb', textDecoration: 'underline' }}>
                        Google Play
                    </a> 또는
                    <a href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb', textDecoration: 'underline' }}>
                        App Store
                    </a> 에서 앱을 다운로드 받으세요.
                </p>
                <div className={styles.qrContainer}>
                  {qrCodeUrl && (
                    <img src={qrCodeUrl} alt="OTP QR Code" className={styles.qrCodeImage} />
                  )}
                </div>

                <div className={styles.secretKey}>
                  {secretKey && (
                      <span className={styles.modalInputText} onClick={() => setShowSecretKey(!showSecretKey)}>
                        {showSecretKey ? 'Secret Key 숨기기' : 'Secret Key 보기'}
                      </span>
                  )}
                  {showSecretKey && <p className={styles.secretKeyText}>{secretKey}</p>}
                </div>

                <div className={styles.passwordInputGroup}>
                  <label htmlFor="current-password" className={styles.passwordLabel}>OTP 인증 코드</label>
                  <input
                    className={styles.passwordInputField}
                    type="text"
                    value={authCode}
                    onChange={(e) => setAuthCode(e.target.value)}
                    placeholder="6자리 인증 코드를 입력하세요"
                  />
                </div>
                <div className={styles.modalButtonRow}>
                  <InnocodeButton
                    size="md"
                    designType="assistive" 
                    fullWidth={true}
                    className={styles.saveBtn}
                    onClick={() => generateOtpQrCode(getCookie("user_id"))}
                  >다시 생성</InnocodeButton>
                  <InnocodeButton
                    size="md"  
                    fullWidth={true}
                    className={styles.saveBtn}
                    onClick={verifyAndRegister}
                  >등록</InnocodeButton>
                  {/* <button className={styles.saveBtn} onClick={() => generateOtpQrCode(getCookie("user_id"))}>다시 생성</button>
                  <button className={styles.saveBtn} onClick={verifyAndRegister}>등록</button> */}
                </div>
              </>
            )}

            {/* 3단계: 기존 QR 코드 불러오기 화면 */}
            {step === "existing-qrcode" && (
              <div>
                <p className={styles.verifyTitle}>OTP 설정이 이미 등록되어 있습니다. 다른 기기에서 사용하시려면 QR 코드를 불러오거나 기존 설정을 삭제할 수 있습니다.</p>
                <div className={styles.modalButtonRow}>
                  <InnocodeButton
                    size="md"
                    designType="assistive"  
                    theme="solid"
                    onClick={() => getExistingQrCode(getCookie("user_id"))}
                  >QR 코드 불러오기</InnocodeButton>
                  <InnocodeButton
                    size="md"   
                    backgroundColor=" var(--status-negative, #f83a3a)"
                    onClick={handleDeletePolicy}
                  >기존 설정 삭제</InnocodeButton>
                    {/* <button className={styles.saveBtn} onClick={() => getExistingQrCode(getCookie("user_id"))}>
                        QR 코드 불러오기
                    </button>
                    <button className={styles.deleteBtn} onClick={handleDeletePolicy}>기존 설정 삭제</button> */}
                </div>
              </div>
            )}
          </>

        </div>
      </div>
    </div>
  );
}

export default OtpRegisterModal;
